'use client'
import {useTracking} from "@/app/contexts/tracking-context";
import {MouseEvent, useCallback} from "react";

interface IMobileAdvertBlock {
    defaultAdvertBlock: string
    isVisible: boolean
}

export default function MobileAdvertBlock({defaultAdvertBlock, isVisible}: IMobileAdvertBlock) {
    const {track} = useTracking();

    const handleClick = useCallback((event: MouseEvent<HTMLDivElement>) => {
        const target = event.target;
        if (target instanceof Element && target.classList) {
            const hasAdvertButton = Array.from(target.classList).some(className =>
                className.includes('wp-block-rm-advertizing-button')
            );

            if (hasAdvertButton) {
                track({
                    event: 'wp_advertizing_button_click',
                    type: 'cta_advertizing_block_sticky'
                });
            }
        }
    }, [track]);

    return (
        <div
            id="default-advertblock"
            onClick={handleClick}
            className={`fixed bottom-0 left-0 z-30 w-full gap-2 flex-col lg:hidden${isVisible ? " flex" : " hidden"}`}
            dangerouslySetInnerHTML={{__html: defaultAdvertBlock}}
        />
    );
}
